module.exports = __webpack_public_path__ + "static/media/hair accessories-white.aacc587b.svg";